import React from 'react';
import styled from 'styled-components';
import { IoMoon, IoSunny } from 'react-icons/io5';
import { useTheme } from '../../contexts/ThemeContext';

/**
 * Botão de alternar tema (claro / escuro).
 * Usa o ThemeContext. Coloque em qualquer lugar dentro do <ThemeProvider>.
 *
 * Props:
 *  - variant: 'header' (compacto, para a barra) | 'block' (largura cheia, para o menu mobile)
 */
export function ThemeToggle({ variant = 'header' }) {
    const { theme, toggleTheme } = useTheme();
    const isDark = theme === 'dark';

    if (variant === 'block') {
        return (
            <BlockButton type="button" onClick={toggleTheme} aria-label="Alternar tema">
                {isDark ? <IoSunny /> : <IoMoon />}
                <span>{isDark ? 'Tema claro' : 'Tema escuro'}</span>
            </BlockButton>
        );
    }

    return (
        <IconButton
            type="button"
            onClick={toggleTheme}
            title={isDark ? 'Tema claro' : 'Tema escuro'}
            aria-label="Alternar tema"
        >
            {isDark ? <IoSunny /> : <IoMoon />}
        </IconButton>
    );
}

const IconButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 38px;
    height: 38px;
    min-width: 38px;
    flex-shrink: 0;
    border-radius: 10px;
    background: rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.22);
    color: #f7f9fc;
    font-size: 18px;
    cursor: pointer;
    transition: background 0.18s ease, transform 0.12s ease;

    &:hover {
        background: rgba(255, 255, 255, 0.18);
        transform: translateY(-1px);
    }
`;

const BlockButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    width: 100%;
    max-width: 360px;
    color: #eef4f6;
    background: rgba(255, 255, 255, 0.08);
    border: 1px solid rgba(255, 255, 255, 0.18);
    border-radius: 12px;
    padding: 12px 18px;
    font-family: inherit;
    font-size: 14px;
    font-weight: 700;
    cursor: pointer;
    transition: background 0.2s ease, transform 0.12s ease;

    svg { font-size: 18px; }

    &:hover {
        background: rgba(255, 255, 255, 0.14);
        transform: translateY(-1px);
    }
`;

export default ThemeToggle;